import moment from 'moment';
import { Chip, Rating, Tooltip, Typography } from '@mui/material';

export const getColumns = (currentPage: number, rows: number) => [
  {
    header: 'S.No.',
    accessor: '_index',
    render: (_row: unknown, index?: number) => (currentPage - 1) * rows + (index ?? 0) + 1,
  },
  {
    header: 'Rating',
    accessor: 'rating',
    render: (row: any) => <Rating value={Number(row.rating) || 0} readOnly size="small" />,
  },
  {
    header: 'Review',
    accessor: 'comment',
    render: (row: any) => row.comment ? (
      <Tooltip title={row.comment}>
        <Typography sx={{ maxWidth: 360 }} noWrap>{row.comment}</Typography>
      </Tooltip>
    ) : '-',
  },
  {
    header: 'Source',
    accessor: 'source',
    render: (row: any) => <Chip size="small" label={row.source === 'externalBooking' ? 'External booking' : 'Booking'} />,
  },
  {
    header: 'User',
    accessor: 'userName',
    render: (row: any) => row.userName || 'Unknown user',
  },
  {
    header: 'Submitted',
    accessor: 'createdAt',
    render: (row: any) => row.createdAt ? moment(row.createdAt).format('DD/MM/YYYY HH:mm') : '-',
  },
];
